import { render, staticRenderFns } from "./patient-balances-settings.vue?vue&type=template&id=792866d0&scoped=true"
import script from "./patient-balances-settings.vue?vue&type=script&lang=js"
export * from "./patient-balances-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792866d0",
  null
  
)

export default component.exports